<div class="info">
  <span [innerHtml]="mainHtml"></span>
</div>
@if (showCheckBox) {
  <p>
    <mat-checkbox (change)="checkboxValueChanged($event)">{{ checkBoxText }}</mat-checkbox>
  </p>
}
